import { useState } from "react";
import { APP_KEY_IDS } from "../../../constants/constants";
import BaseMobileAppContainer from "../base-mobile-app-container/BaseMobileAppContainer";
import Styles from "./Skills.module.scss";
import MobileOptionsList from "../mobile-options-list/MobileOptionsList";
import { getCurrentOption } from "../../../global/functions/functrions";
interface SkillsProps {
  skillsData: any
  proficiency: any;
}

const Skills = ({ skillsData, proficiency }: SkillsProps) => {



  const leftMenu = [
    {
      id: "AIML",
      label: "AIML"
    },
    {
      id: "Android",
      label: "Android"
    },
    {
      id: "ChromeExtension",
      label: "Chrome Extension"
    },
    {
      id: "Databse",
      label: "Databse"
    },
    {
      id: "Desktop",
      label: "Desktop"
    },
    {
      id: "OS&Other",
      label: "OS & Other"
    },
    {
      id: "Tools&Technologies",
      label: "Tools & Technologies"
    },
    {
      id: "UI Designing",
      label: "UI Designing"
    },
    {
      id: "WebApp",
      label: "Web App"
    },
    {
      id: "WebSites",
      label: "Website"
    }
  ]


  const [activeOption, setActiveOption] = useState<any>("");

  const handleBackClick = () => {
    setActiveOption("")
  }

  return (
    <BaseMobileAppContainer
      title={skillsData[getCurrentOption(activeOption)]?.label || "Development Skills"}
      appId={APP_KEY_IDS.MOBILE_DEV_SKILLS}
      MainMenuOptions={
        <div style={{flexDirection:"column", width:"100%"}}>
          <MobileOptionsList menuContent={Object.values(skillsData)} activeValue={activeOption} handleOptionClick={setActiveOption} />
            <div className={Styles.proficiencies}>
              <div className={Styles.title}>
                Proficiency
              </div>
            {
              Object.keys(proficiency).map((key: string) => {
                return (
                  <div className={Styles.proficiency_card} key={proficiency[key].pname}>
                    <div className={Styles.card}>
                      <div className={Styles.label}>
                        {proficiency[key].pname}
                      </div>
                      <div className={Styles.experience}>
                        {proficiency[key].pyrs}
                      </div>
                      <div className={Styles.prcnt}>
                        {proficiency[key].pprcnt}
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>}
      isMainScreenActive={!!activeOption}
      MainScreen={
        <div className={Styles.main_screen} >
          <div className={Styles.title}>
            {skillsData[getCurrentOption(activeOption)]?.label || "Development Skills"}
          </div>
          <div className={Styles.skills}>
            {activeOption &&
              Object.keys(skillsData[getCurrentOption(activeOption)]?.skills).map((key) => {
                return (
                  <a className={Styles.skill_card} href={skillsData[getCurrentOption(activeOption)].skills[key].skillLink} key={key} target="_blank">
                    <div className={Styles.skill_icon}>
                      <img src={skillsData[getCurrentOption(activeOption)].skills[key].skillIcon} />
                    </div>
                    <div className={Styles.skill_name}>
                      {skillsData[getCurrentOption(activeOption)].skills[key].skillName}
                    </div>
                  </a>

                )
              })}
          </div>
        </div>
      }

      handleBackClick={handleBackClick}
    />
  )
}

export default Skills
